<div
  class="input-value-container"
  ngClass="{{ !formName.valid && formName.touched ? 'input-value-container--invalid' : '' }}"
  >
  <input
    class="input-value"
    (input)="textInputUpdated()"
    [(ngModel)]="currentInputValue"
    [placeholder]="placeholder"
    (compositionstart)="onCompositionStart()"
    (compositionend)="onCompositionEnd($event)"
    >
  </div>

  <div class="text-placeholder">
    @if (invalidText && formName.touched && formName.invalid) {
      <div class="invalid-input-text">
        <div>{{ invalidText | translate }}</div>
      </div>
    }
  </div>